import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

// Guard RBAC: consente l'accesso alle rotte admin solo agli utenti con profile.is_admin.
// La vera protezione resta server-side (403); questo migliora UX ed evita l'esposizione della UI admin.
export const RequireAdmin = ({ children }) => {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="require-admin-loading">
        <Loader2 className="w-8 h-8 animate-spin text-[#008080]" />
      </div>
    );
  }

  if (!user || profile?.is_admin !== true) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default RequireAdmin;
